(() => {
  if (customElements.get('yakjak-spin')) return;
  class YakJakSpin extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      let frames;
      try { frames = this.frames || JSON.parse(this.querySelector('[data-spin-frames]').textContent); }
      catch { return; }
      if (!Array.isArray(frames) || frames.length < 2) return;
      this.frames = frames.filter(frame => frame && typeof frame.src === 'string');
      if (this.frames.length < 2) return;
      this.initialized = true;
      this.index = Math.max(0,Math.min(Number(this.dataset.start)||0,this.frames.length-1));
      this.requested = this.index;
      this.loads = new Map();
      this.token = 0;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.innerHTML = `
        <div class="yj-spin-top"><span class="yj-spin-tag">360° VIEW</span><span class="yj-spin-tag" data-counter></span></div>
        <div class="yj-spin-stage" tabindex="0" role="group" aria-label="Rotating product image. Drag horizontally or use left and right arrow keys.">
          <img width="1600" height="1067" draggable="false" decoding="async">
        </div>
        <span class="yj-spin-hint">↔ Drag to rotate</span>
        <p class="yj-spin-error" role="status" hidden></p>
        <div class="yj-spin-tools">
          <div class="yj-spin-controls">
            <button type="button" data-prev aria-label="Previous angle">←</button>
            <button type="button" class="yj-spin-play" aria-pressed="false" aria-label="Automatically rotate the product" data-play><span aria-hidden="true">▶</span><span data-play-label>Rotate</span></button>
            <button type="button" data-next aria-label="Next angle">→</button>
          </div>
          <input class="yj-spin-range" type="range" min="0" step="1" aria-label="Product viewing angle">
          <button type="button" class="yj-spin-expand" data-expand aria-label="Expand product view">⤢ <span>Expand</span></button>
        </div>
        <div class="yj-spin-thumbs" role="group" aria-label="Choose a product angle"></div>
        <p class="yj-spin-sr" data-announce aria-live="polite" aria-atomic="true"></p>`;
      this.stage = this.querySelector('.yj-spin-stage');
      this.image = this.stage.querySelector('img');
      this.range = this.querySelector('input');
      this.range.max = this.frames.length - 1;
      this.counter = this.querySelector('[data-counter]');
      this.error = this.querySelector('.yj-spin-error');
      this.announce = this.querySelector('[data-announce]');
      this.playButton = this.querySelector('[data-play]');
      this.thumbs = [];
      const tray = this.querySelector('.yj-spin-thumbs');
      this.frames.forEach((frame,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'yj-spin-thumb';
        button.setAttribute('aria-label',`Show angle ${index+1}: ${frame.alt || 'Product view'}`);
        const image = document.createElement('img');
        image.src = frame.thumb || frame.src;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 240;
        image.height = 160;
        const number = document.createElement('span');
        number.textContent = String(index+1).padStart(2,'0');
        button.append(image,number);
        button.addEventListener('click',() => {this.pause();this.show(index,true);},{signal});
        tray.append(button);
        this.thumbs.push(button);
      });
      this.paint(this.index);
      this.querySelector('[data-prev]').addEventListener('click',() => this.step(-1),{signal});
      this.querySelector('[data-next]').addEventListener('click',() => this.step(1),{signal});
      this.playButton.addEventListener('click',() => this.timer ? this.pause() : this.play(),{signal});
      this.range.addEventListener('input',() => {this.pause();this.show(Number(this.range.value),true);},{signal});
      this.stage.addEventListener('keydown',event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();event.stopPropagation();this.pause();
        if(event.key==='Home')this.show(0,true);
        else if(event.key==='End')this.show(this.frames.length-1,true);
        else this.step(event.key==='ArrowRight'?1:-1);
      },{signal});
      this.stage.addEventListener('pointerdown',event => {
        if(!event.isPrimary || event.button!==0)return;
        event.stopPropagation();this.pause();this.preload();
        this.drag={x:event.clientX,y:event.clientY,index:this.requested,id:event.pointerId};
        this.stage.setPointerCapture(event.pointerId);
      },{signal});
      this.stage.addEventListener('pointermove',event => {
        if(!this.drag || this.drag.id!==event.pointerId)return;
        const dx=event.clientX-this.drag.x,dy=event.clientY-this.drag.y;
        if(Math.abs(dx)<8 || Math.abs(dy)>Math.abs(dx)*1.4)return;
        event.stopPropagation();
        if(event.cancelable)event.preventDefault();
        const distance=Math.max(24,this.stage.clientWidth/this.frames.length);
        const frame=this.wrap(this.drag.index-Math.round(dx/distance));
        if(frame!==this.requested)this.show(frame,false);
      },{signal,passive:false});
      const endDrag=event=>{
        if(!this.drag || event.pointerId!==this.drag.id)return;
        this.drag=null;
        if(this.stage.hasPointerCapture(event.pointerId))this.stage.releasePointerCapture(event.pointerId);
        this.announce.textContent=`Angle ${this.index+1} of ${this.frames.length}`;
      };
      this.stage.addEventListener('pointerup',endDrag,{signal});
      this.stage.addEventListener('pointercancel',endDrag,{signal});
      this.stage.addEventListener('lostpointercapture',()=>{this.drag=null;},{signal});
      const expand=this.querySelector('[data-expand]');
      if(this.hasAttribute('data-expanded'))expand.remove();
      else expand.addEventListener('click',()=>this.expand(),{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.pause();},{signal});
      this.observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){this.preload();this.observer.disconnect();}
      },{rootMargin:'200px'});
      this.observer.observe(this);
      this.visibilityObserver=new IntersectionObserver(entries=>{
        if(entries.every(entry=>!entry.isIntersecting))this.pause();
      });
      this.visibilityObserver.observe(this);
    }
    wrap(index){return (index%this.frames.length+this.frames.length)%this.frames.length;}
    load(index){
      if(!this.loads.has(index)){
        const promise=new Promise((resolve,reject)=>{
          const image=new Image();
          image.onload=()=>image.decode().catch(()=>{}).then(()=>resolve(image));
          image.onerror=()=>reject(new Error('Angle unavailable'));
          image.src=this.frames[index].src;
        });
        this.loads.set(index,promise);
      }
      return this.loads.get(index);
    }
    preload(){this.frames.forEach((_,index)=>this.load(index).catch(()=>{}));}
    paint(index){
      this.index=index;
      this.dataset.frame=String(index);
      this.image.src=this.frames[index].src;
      this.image.alt=this.frames[index].alt || `Product angle ${index+1}`;
      this.counter.textContent=`${String(index+1).padStart(2,'0')} / ${String(this.frames.length).padStart(2,'0')}`;
      this.range.value=index;
      this.thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    }
    async show(index,announce=false){
      index=this.wrap(index);
      this.requested=index;
      const token=++this.token;
      try{
        await this.load(index);
        if(token!==this.token || !this.isConnected)return;
        this.error.hidden=true;
        this.paint(index);
        if(announce)this.announce.textContent=`Angle ${index+1} of ${this.frames.length}`;
      }catch{
        if(token!==this.token)return;
        this.pause();
        this.range.value=this.index;
        this.error.textContent='This angle could not load. Choose another angle, or try again.';
        this.error.hidden=false;
        this.loads.delete(index);
      }
    }
    step(delta){this.pause();this.show(this.requested+delta,true);}
    play(){
      this.preload();
      this.timer=setInterval(()=>this.show(this.requested+1),700);
      this.playButton.setAttribute('aria-pressed','true');
      this.playButton.setAttribute('aria-label','Pause product rotation');
      this.playButton.querySelector('[data-play-label]').textContent='Pause';
      this.playButton.firstElementChild.textContent='Ⅱ';
    }
    pause(){
      clearInterval(this.timer);this.timer=null;
      if(!this.playButton)return;
      this.playButton.setAttribute('aria-pressed','false');
      this.playButton.setAttribute('aria-label','Automatically rotate the product');
      this.playButton.querySelector('[data-play-label]').textContent='Rotate';
      this.playButton.firstElementChild.textContent='▶';
    }
    expand(){
      this.pause();
      const dialog=document.createElement('dialog');
      dialog.className='yj-spin-dialog';
      dialog.setAttribute('aria-label','Expanded 360-degree product view');
      const header=document.createElement('div');header.className='yj-spin-dialog-head';
      const title=document.createElement('span');title.textContent='YakJak™ · 360° view';
      const close=document.createElement('button');close.type='button';close.className='yj-spin-close';close.textContent='Close ×';
      const viewer=document.createElement('yakjak-spin');viewer.frames=this.frames;viewer.dataset.expanded='';viewer.dataset.start=this.index;
      header.append(title,close);dialog.append(header,viewer);document.body.append(dialog);
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>{
        this.show(viewer.index);
        dialog.remove();
        this.querySelector('[data-expand]')?.focus();
      },{once:true});
      this.dialog=dialog;dialog.showModal();
    }
    disconnectedCallback(){
      this.pause();this.controller?.abort();this.observer?.disconnect();this.visibilityObserver?.disconnect();
      this.dialog?.remove();this.initialized=false;
      this.token++;
    }
  }
  customElements.define('yakjak-spin',YakJakSpin);
})();
